import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Footer from "@/components/Footer";
import { ChallengeCard, useChallengeActions } from "@/pages/Challenges";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ChallengeDetail() {
  const { slug } = useParams();
  const [challenge, setChallenge] = useState(null);
  const [missing, setMissing] = useState(false);
  const actions = useChallengeActions();

  useEffect(() => {
    axios
      .get(`${API}/challenges`)
      .then((r) => {
        const found = r.data.find((c) => c.slug === slug);
        if (found) setChallenge(found);
        else setMissing(true);
      })
      .catch(() => setMissing(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#FBF9F5]">
      <PageHeader />
      <main className="px-6 sm:px-12 lg:px-20 pt-32 sm:pt-40 pb-24 sm:pb-32 max-w-4xl mx-auto" data-testid="challenge-detail">
        <Link
          to="/challenges"
          className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#6B7280] hover:text-[#FF4E00] transition-colors mb-8"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> All Challenges
        </Link>
        {missing && (
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#6B7280]">Challenge not found.</p>
        )}
        {challenge && (
          <ChallengeCard
            c={challenge}
            participantId={actions.joined[challenge.slug]}
            busy={actions.busy[challenge.slug]}
            syncTick={actions.syncTick}
            onJoin={actions.join}
            onConnect={actions.connect}
            onSync={actions.sync}
            form={actions.forms[challenge.slug] || actions.prefill}
            setForm={(f) => actions.setForms((all) => ({ ...all, [challenge.slug]: f }))}
          />
        )}
      </main>
      <Footer />
    </div>
  );
}
